import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import organiseTodosImg from "../images/organise-todos-img.png"
import happyAnnouncementImg from "../images/happy-announcement-img.png"
import newIdeasImg from "../images/new-ideas-img.png"
import orderTodosImg from "../images/order-todos-img.png"
import todosDoneImg from "../images/todos-done-img.png"
import workTodosImg from "../images/work-todos-img.png"
import listTodosImg from "../images/list-todos-img.png"
import todosRemoveImg from "../images/todos-remove-img.png"
import addTodoWithEaseImg from "../images/addTodoWithEase-img.png"



const TodoCarousel = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000

    };

    return (
        <>
            <div className="carousel-wrapper">
                <Slider {...settings}>
                    <div className="carousel-item">
                        <img
                            src={organiseTodosImg}
                            alt="todo carousel"
                        />
                    </div>
                    <div className="carousel-item">
                        <img
                            src={happyAnnouncementImg}
                            alt="todo carousel"
                        />
                    </div>
                    <div className="carousel-item">
                        <img
                            src={newIdeasImg}
                            alt="todo carousel"
                        />
                    </div>
                    <div className="carousel-item">
                        <img
                            src={orderTodosImg}
                            alt="todo carousel"
                        />
                    </div>
                    <div className="carousel-item">
                        <img
                            src={todosDoneImg}
                            alt="todo carousel"
                        />
                    </div>
                    <div className="carousel-item">
                        <img
                            src={workTodosImg}
                            alt="todo carousel"
                        />
                    </div>
                    <div className="carousel-item">
                        <img
                            src={listTodosImg}
                            alt="todo carousel"
                        />
                    </div>
                    <div className="carousel-item">
                        <img
                            src={todosRemoveImg}
                            alt="todo carousel"
                        />
                    </div>
                    <div className="carousel-item">
                        <img
                            src={addTodoWithEaseImg}
                            alt="todo carousel"
                        />
                    </div>
                </Slider>
            </div>
        </>
    )
}


export default TodoCarousel;